import { Link, useLocation } from "react-router-dom";
import { Home, LayoutGrid, Search, Heart, User } from "lucide-react";
import { useShop } from "@/context/ShopContext";

export default function MobileNav() {
  const { pathname } = useLocation();
  const { cart } = useShop();
  const items = [
    { to: "/", icon: Home, label: "Home", key: "home" },
    { to: "/shop", icon: LayoutGrid, label: "Shop", key: "shop" },
    { to: "/shop", icon: Search, label: "Search", key: "search" },
    { to: "/wishlist", icon: Heart, label: "Wishlist", key: "wishlist" },
    { to: "/account", icon: User, label: "Account", key: "account" },
  ];
  return (
    <nav data-testid="mobile-bottom-nav" className="lg:hidden fixed bottom-0 left-0 right-0 z-40 glass border-t border-black/10">
      <div className="grid grid-cols-5">
        {items.map((it) => {
          const active = pathname === it.to;
          return (
            <Link key={it.key} to={it.to} data-testid={`bottomnav-${it.key}`} className={`flex flex-col items-center gap-0.5 py-2.5 text-[10px] font-medium ${active ? "text-gold-dark" : "text-muted-foreground"}`}>
              <it.icon className="h-5 w-5" />
              {it.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
